import React from 'react';
import Facebook from '@material-ui/icons/Facebook';

export default function FacebookIcon(props) {
    const { ...other } = props;

    return (
        <Facebook {...other} />
    );
}